export const formatDate = (dateString: string): string => {
  if (!dateString) return '';

  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return '';
  }

  // Format the date
  return date.toLocaleDateString('en-US', {
    month: 'short', // "Feb"
    day: 'numeric', // "19"
    year: 'numeric', // "2025"
  });
};
